import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { trackCheckoutCancel } from '@/services/analytics';

export const CheckoutCancelPage = () => {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackCheckoutCancel();
  }, []);

  return (
    <div
      className="container-main"
      style={{
        maxWidth: '640px',
        paddingTop: 'var(--space-16)',
        paddingBottom: 'var(--space-16)',
      }}
    >
      <div
        className="text-center"
        style={{
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-default)',
          backgroundColor: 'var(--bg-surface)',
          padding: 'var(--space-6)',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            borderRadius: 'var(--radius-full)',
            backgroundColor: 'var(--bg-surface-sunken)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto var(--space-6)',
          }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--text-tertiary)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>

        <h1
          style={{
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          Checkout Cancelled
        </h1>
        <p
          style={{
            marginTop: 'var(--space-2)',
            color: 'var(--text-tertiary)',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          Your payment was not processed. No charges were made.
          You can try again whenever you're ready.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-3)',
            marginTop: 'var(--space-8)',
            maxWidth: '280px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Link to="/quotes">
            <Button style={{ width: '100%' }}>Back to My Quotes</Button>
          </Link>
          <Link to="/catalog">
            <Button
              variant="secondary"
              style={{ width: '100%' }}
            >
              Browse Catalog
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
